/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SettlementControllerDtoDoSettlementRequest model module.
 * @module model/SettlementControllerDtoDoSettlementRequest
 * @version 1.0
 */
class SettlementControllerDtoDoSettlementRequest {
    /**
     * Constructs a new <code>SettlementControllerDtoDoSettlementRequest</code>.
     * @alias module:model/SettlementControllerDtoDoSettlementRequest
     */
    constructor() { 
        
        SettlementControllerDtoDoSettlementRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SettlementControllerDtoDoSettlementRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SettlementControllerDtoDoSettlementRequest} obj Optional instance to populate.
     * @return {module:model/SettlementControllerDtoDoSettlementRequest} The populated <code>SettlementControllerDtoDoSettlementRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SettlementControllerDtoDoSettlementRequest();

            if (data.hasOwnProperty('issuer')) {
                obj['issuer'] = ApiClient.convertToType(data['issuer'], 'String');
            }
            if (data.hasOwnProperty('dryRun')) {
                obj['dryRun'] = ApiClient.convertToType(data['dryRun'], 'Boolean');
            }
            if (data.hasOwnProperty('settlementIds')) {
                obj['settlementIds'] = ApiClient.convertToType(data['settlementIds'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SettlementControllerDtoDoSettlementRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SettlementControllerDtoDoSettlementRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['issuer'] && !(typeof data['issuer'] === 'string' || data['issuer'] instanceof String)) {
            throw new Error("Expected the field `issuer` to be a primitive type in the JSON string but got " + data['issuer']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['settlementIds'])) {
            throw new Error("Expected the field `settlementIds` to be an array in the JSON data but got " + data['settlementIds']);
        }

        return true;
    }


}



/**
 * @member {String} issuer
 */
SettlementControllerDtoDoSettlementRequest.prototype['issuer'] = undefined;

/**
 * @member {Boolean} dryRun
 */
SettlementControllerDtoDoSettlementRequest.prototype['dryRun'] = undefined;

/**
 * @member {Array.<String>} settlementIds
 */
SettlementControllerDtoDoSettlementRequest.prototype['settlementIds'] = undefined;






export default SettlementControllerDtoDoSettlementRequest;

